export function getVimeoId(url) {
    let match = /vimeo.*\/(\d+)/i.exec(url);

    if (match) {
        return match[1];
    } else {
        return;
    }
}
